"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgrammeSupportedTypesEnum = exports.ProgrammeSupportedTypes = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const GenericEntityTypes_1 = require("./GenericEntityTypes");
const defaultProgrammeSupportedTypes = config_1.default.apps?.webUI?.pruneGenericEntities ? [] : GenericEntityTypes_1.GenericEntityClassNames;
exports.ProgrammeSupportedTypes = [...defaultProgrammeSupportedTypes, ...(config_1.default.ventureTypeExtensions?.Programme?.supportedTypes || [])];
exports.ProgrammeSupportedTypesEnum = (0, iotv_v3_types_1.getEnumShape)(exports.ProgrammeSupportedTypes);
